/** Tampon d'erreurs avant init Sentry (max 20) — rejoué via captureException puis handlers retirés. */

const MAX_ENTRIES = 20;

type BufferedEntry = {
  kind: 'error' | 'rejection';
  error: unknown;
  at: number;
};

const buffer: BufferedEntry[] = [];
let installed = false;
let flushed = false;

let onErrorHandler: ((event: ErrorEvent) => void) | null = null;
let onRejectionHandler: ((event: PromiseRejectionEvent) => void) | null = null;

function pushEntry(entry: BufferedEntry): void {
  if (flushed) return;
  if (buffer.length >= MAX_ENTRIES) buffer.shift();
  buffer.push(entry);
}

/** À appeler synchronously au boot (index.tsx), avant scheduleSentryInit. */
export function installPreSentryErrorBuffer(): void {
  if (typeof window === 'undefined' || installed) return;
  installed = true;

  onErrorHandler = (event: ErrorEvent) => {
    pushEntry({
      kind: 'error',
      error: event.error ?? event.message ?? 'Unknown error',
      at: Date.now(),
    });
  };

  onRejectionHandler = (event: PromiseRejectionEvent) => {
    pushEntry({
      kind: 'rejection',
      error: event.reason,
      at: Date.now(),
    });
  };

  window.addEventListener('error', onErrorHandler);
  window.addEventListener('unhandledrejection', onRejectionHandler);
}

function removeHandlers(): void {
  if (onErrorHandler) {
    window.removeEventListener('error', onErrorHandler);
    onErrorHandler = null;
  }
  if (onRejectionHandler) {
    window.removeEventListener('unhandledrejection', onRejectionHandler);
    onRejectionHandler = null;
  }
}

export function flushPreSentryErrorBuffer(captureException: (error: unknown) => void): void {
  if (flushed) return;
  flushed = true;
  removeHandlers();

  for (const entry of buffer) {
    try {
      if (entry.error instanceof Error) {
        captureException(entry.error);
      } else {
        captureException(new Error(String(entry.error)));
      }
    } catch {
      /* ignore */
    }
  }
  buffer.length = 0;
}

/** Tests uniquement. */
export function __resetPreSentryErrorBufferForTests(): void {
  buffer.length = 0;
  flushed = false;
  installed = false;
  removeHandlers();
}
